import React, { useState } from 'react';

import './styles/index.css';

import Game from './game';
import CountDownTimer from './tools/countdown'




import { Col, Row } from 'react-bootstrap';


/* holds the timer and game. When timer ends, it will set the timerStopped to true and pass this flag to Game component to display the disabled grids
*/

export default function GameHolder(props) {

    const [timerStoped, setTimerStoped] = useState(false);
    const [randomStart, setRandomStart] = useState("");
    const { selectNewGame } = props; //to pass callback


    const onSelectTimer = () => {
        setTimeout(() => setTimerStoped(true), 0);
    }

    const onSelectRestart = (status) => {

        setRandomStart(+new Date()); //a dummy to force a reload of the timer component. +new date convert current date to millisecons
        setTimerStoped(false);
        if (status === "newgame") {
            selectNewGame("newgame");
        }
    }


    return (
        <div>
            
            <Row id="non-printable" className="timer-gap">
                <Col xs={1} md={5}>
                    &nbsp;
                </Col>
                <Col className="transparentBackground timerText text-center">
                    {timerStoped === false && <CountDownTimer duration={props.duration} randomstart={randomStart} selectTimerStop = {onSelectTimer} /> }
                    {timerStoped === true && <>00:00</> }
                </Col>
                <Col  xs={1} md={5}>
                    &nbsp;
                </Col>
            </Row>
         
            <Row>
                <Col>
                    {/* <Game timerStoped={timerStoped} type={props.type} selectRestart={onSelectRestart} chord={props.chord} /> */}
                    <Game groupcode={props.groupcode} timerStoped={timerStoped} type={props.type} selectRestart={onSelectRestart} chord={props.chord} volume={props.volume} duration={props.duration}/>
                </Col>


            </Row>
            {/* <Label /> */}

        </div>
    )
}